/**
 * @file Burn component: damage over time left behind by the flamethrower.
 *
 * Numbers only, like {@link ./Health.js}. {@link ../systems/BurnSystem.js}
 * counts it down and routes the damage through the normal `damage` event, so a
 * burn respects shields and invulnerability exactly like a bullet does.
 *
 * Re-applying a burn refreshes it instead of stacking — see
 * {@link ../systems/StreamFlameSystem.js} — so holding the trigger on one
 * enemy can never build an unbounded damage-over-time.
 */

import { Component } from '../ecs/Component.js';

export class Burn extends Component {
  /**
   * @param {number} [damagePerSecond] Damage dealt per second while it lasts.
   * @param {number} [duration] Seconds it lasts.
   */
  constructor(damagePerSecond = 0, duration = 0) {
    super();
    /** @type {number} */
    this.damagePerSecond = damagePerSecond;
    /** @type {number} Duration of the most recent application. */
    this.duration = duration;
    /** @type {number} Seconds left. */
    this.remaining = duration;
  }

  /** @returns {void} */
  reset() {
    this.remaining = this.duration;
  }
}
